var map = {
	"./1-sgi-ingreso-v1.png": 43,
	"./1-sgi-ingreso-v2.png": 44,
	"./2-sgi-home-v1.png": 45,
	"./2-sgi-home-v2.png": 46,
	"./3-sgi-home-v1.png": 47,
	"./3-sgi-home-v1.png:Zone.Identifier": 87,
	"./3-sgi-home-v2.png": 48,
	"./3-sgi-home-v2.png:Zone.Identifier": 88,
	"./4-sgi-home-v1.png": 49,
	"./4-sgi-home-v1.png:Zone.Identifier": 89,
	"./4-sgi-home-v2.png": 50,
	"./4-sgi-home-v2.png:Zone.Identifier": 90,
	"./5-sgi-home-v1.png": 51,
	"./5-sgi-home-v1.png:Zone.Identifier": 91,
	"./5-sgi-home-v2.png": 52,
	"./5-sgi-home-v2.png:Zone.Identifier": 92,
	"./6-sgi-matricula-v1.png": 53,
	"./6-sgi-matricula-v1.png:Zone.Identifier": 93,
	"./6-sgi-matricula-v2-01.png:Zone.Identifier": 94,
	"./6-sgi-matricula-v2.png": 54,
	"./7-sgi-matricula-v1.png": 55,
	"./7-sgi-matricula-v1.png:Zone.Identifier": 95,
	"./7-sgi-matricula-v2-02.png:Zone.Identifier": 96,
	"./7-sgi-matricula-v2.png": 56,
	"./8-sgi-documentos-v1.png": 57,
	"./8-sgi-documentos-v1.png:Zone.Identifier": 97,
	"./8-sgi-documentos-v2.png": 58,
	"./8-sgi-documentos-v2.png:Zone.Identifier": 98,
	"./login_1.jpg": 25,
	"./login_2.jpg": 26,
	"./login_3.jpg": 27,
	"./login_4.jpg": 28,
	"./login_5.jpg": 29,
	"./login_6.jpg": 30,
	"./login_background.png": 21,
	"./logo_ulagos.png": 23,
	"./reference_images/competencias-genericas-2024/2/0.jpg": 41,
	"./reference_images/test-survey-no-applicant/0/2.jpg": 42,
	"./splash_images/1..JPG:Zone.Identifier": 99,
	"./splash_images/1.jpg": 34,
	"./splash_images/2.jpg": 35,
	"./splash_images/3.jpg": 36,
	"./splash_images/4.jpg": 37,
	"./splash_images/5.jpg": 38,
	"./splash_images/6.jpg": 39,
	"./splash_images/7.jpg": 40,
	"./ulagos_bco-11.png": 17,
	"./ulises_login.png": 22,
	"./undraw_posting_photo.svg": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;